import axios from "axios";

import { getApiBaseUrl, getFileBaseUrl } from "@config/config";

import { getAccessToken } from "@service/tokenService";

export const BASE_URLS = {
  api: getApiBaseUrl(),
  file: getFileBaseUrl(),
};

export const apiClient = axios.create({
    baseURL: BASE_URLS.api,
    headers: {
        'Content-Type': 'application/json',
    },
    timeout: 15000,
});

export const fileClient = axios.create({
    baseURL: BASE_URLS.file,
    headers: {
        'Content-Type': 'application/json',
    },
    timeout: 15000,
});

export const clients = [apiClient, fileClient];

clients.forEach(client => {
    client.interceptors.request.use(
      (config) => {
        const token = getAccessToken();
        if (token) {
          config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
      },
      (error) => Promise.reject(error)
    );
  });

let refreshingFunc = undefined; // mini-mutex baby ;)

export const setupInterceptors = (logoutMutate, refreshTokenMutate) => {

    clients.forEach(client => {  
        client.interceptors.response.use(
            response => response,
            async error => {
                if (error.response.status !== 401) {
                    return Promise.reject(error);
                }

                const authHeader = error.response?.headers?.['www-authenticate']?.toLowerCase();
                const shouldRefresh = authHeader && 
                    (authHeader.includes('invalid_token') || 
                    authHeader.includes('token_expired') ||
                    authHeader.includes('token_revoked'));

                if (!shouldRefresh) {
                    return Promise.reject(error);
                }

                const originalConfig = error.config;

                if (!refreshingFunc) {
                    refreshingFunc = new Promise((resolve, reject) => {
                        refreshTokenMutate(undefined, {
                            onSuccess: (data) => {
                                resolve(data.data.access_token);
                            },
                            onError: reject,
                        });
                    });
                }

                return refreshingFunc
                    .then((newAccessToken) => {
                        originalConfig.headers.Authorization = `Bearer ${newAccessToken}`;

                        return client.request(originalConfig)
                            .then(response => response)
                            .catch(error => {
                                logoutMutate();
                                return Promise.reject(error);
                            });
                    })
                    .catch(error => {
                        logoutMutate();
                        return Promise.reject(error);
                    })
                    .finally(() => {
                        refreshingFunc = undefined;
                    });
            }
        );
    });
};
